/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useTranslate } from "../../translate";
import { Formik, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Button from "@ingka/button";
import ValidationErrorMessage from "../ValidationErrorMessage";
import * as Yup from "yup";

import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/forms/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/hyperlink/style.scss";
import "@ingka/svg-icon/style.scss";
import "./TrackOrderModalBody.scss";
import {
  fetchOrderByOrderNumber,
  resetTrackedOrder,
} from "../../redux/trackOrder/trackOrderAction";

import orderConfirmedImg from "../../images/track-order/order_confirmed.png";
import deliveredImg from "../../images/track-order/delivered.png";
import onItsWayImg from "../../images/track-order/on_its_way.png";
import preparingOrderImg from "../../images/track-order/preparing_order.png";

import infoIcon from "@ingka/ssr-icon/paths/information-circle";
import SSRIcon from "@ingka/ssr-icon";

const TrackOrderModalBody = () => {
  const dispatch = useDispatch();
  const i18n = useTranslate();
  const { t, isRtl, getCurrentLanguageCode } = i18n;

  const orderDetails = useSelector(
    ({ trackOrder }) => trackOrder?.orderByOrderNumber?.order
  );
  const trackOrderFetchingStatus = useSelector(
    ({ trackOrder }) => trackOrder?.orderByOrderNumber?.fetchingStatus?.state
  );

  const orderErrorMsg = useSelector(
    ({ trackOrder }) => trackOrder?.orderByOrderNumber?.error
  );
  const trackOrderInitialValue = {
    orderNumber: "",
  };

  const orderNumberRegex = new RegExp(
    `^WEBO[a-z0-9]{7}$|^554[a-z0-9]{8}$|^218[a-z0-9]{8}$|^055[a-z0-9]{8}$`
  );

  const trackOrderValidationSchema = Yup.object({
    orderNumber: Yup.string()
      .required(t("trackOrderModalBody.orderNumber.required.text"))
      .matches(
        orderNumberRegex,
        t("trackOrderModalBody.orderNumber.valid.text")
      ),
  });

  const currentLanguageCode = getCurrentLanguageCode();
  const handleTrackOrderByOrderNumberBtnClick = ({ orderNumber }) => {
    dispatch(resetTrackedOrder());
    dispatch(
      fetchOrderByOrderNumber({
        orderNumber: orderNumber,
        lang: currentLanguageCode,
      })
    );
  };

  useEffect(() => {
    dispatch(resetTrackedOrder());
  }, []);

  const closeAndReTrack = () => {
    dispatch(resetTrackedOrder());
  };

  const isActive = (boxNumer, currentStatus) => {
    const statusList = [
      "Ready to Assign",
      "Service Provider Contacted",
      "Handed over to Service Provider",
      "Completed",
    ];
    let className = "track-images-wrapper";
    if (boxNumer <= statusList.indexOf(currentStatus)) {
      return `${className} activebox`;
    }
    return className;
  };

  const handleFormKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <div className="track-order-modal-body" dir={isRtl() ? "rtl" : "ltr"}>
      <div className="header">
        <div className="header-title">
          {t("trackOrderModalBody.header.title")}
        </div>
        <div className="header-desc">
          {t("trackOrderModalBody.header.desc")}
        </div>
      </div>
      <hr />
      <div className="track-order-section">
        <Formik
          initialValues={trackOrderInitialValue}
          validationSchema={trackOrderValidationSchema}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setStatus,
            status,
            isValid,
            dirty,
            resetForm,
            /* and other goodies */
          }) => (
            <form onKeyDown={handleFormKeyDown}>
              <div className="track-order-text-field-container">
                <div className="form-field">
                  <div className="input-field label-wrapper label-wrapper--text-input mobile-no-field">
                    <label
                      htmlFor="orderNumber"
                      title={t(
                        "trackOrderModalBody.orderNumber.textField.label"
                      )}
                    >
                      {t("trackOrderModalBody.orderNumber.textField.label")}
                    </label>
                    <div className="input-field__wrapper">
                      {/* <div className="order-code">
                        {t("trackOrderModalBody.orderNumber.textField.prefix")}
                      </div> */}
                      <input
                        type="text"
                        aria-describedby="orderNumber"
                        aria-required="false"
                        id="orderNumber"
                        name="orderNumber"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.orderNumber}
                        placeholder={t(
                          "trackOrderModalBody.orderNumber.textField.placeholder"
                        )}
                        autoComplete="off"
                      />
                      <span className="input-field__border"></span>
                    </div>
                  </div>
                  <div className="validation-error-msg-space">
                    <ErrorMessage
                      name="orderNumber"
                      component={ValidationErrorMessage}
                    />
                  </div>
                </div>
              </div>
              {orderErrorMsg && (
                <div className="response-error-msg-space">
                  <ValidationErrorMessage>
                    <SSRIcon paths={infoIcon} />
                    {t("trackOrderModalBody.orderNumber.notFound")}
                  </ValidationErrorMessage>
                </div>
              )}
              <div className="track-order-btn-container">
                <Button
                  className="track-order-btn"
                  type="emphasised"
                  text={t("trackOrderModalBody.orderNumber.btn.text")}
                  onClick={() => {
                    handleTrackOrderByOrderNumberBtnClick({
                      orderNumber: values.orderNumber,
                    });
                  }}
                  disabled={
                    !(dirty && isValid) ||
                    trackOrderFetchingStatus === "inProgress"
                  }
                />
              </div>
              {orderDetails !== undefined && orderDetails?.DocumentNo && (
                <>
                  <hr />
                  <div className="track-order-tracking-container">
                    <div className="tracking-status-container">
                      <div className="tracking-number">
                        <span>
                          {t(
                            "trackOrderModalBody.orderNumber.trackingNumber.text"
                          )}
                          {" : "}
                        </span>
                        <span className="trackOrder-font">
                          {orderDetails?.DocumentNo}
                        </span>
                      </div>
                      <div className="estimated-delivery trackOrder-font">
                        {t("trackOrderModalBody.orderNumber.estimated.text")}{" "}
                        {orderDetails?.ServiceDate} {orderDetails?.ServiceTime}
                      </div>
                      <div className="tracking-images-container">
                        <span className={isActive(0, orderDetails?.Status)}>
                          <span>
                            <span className="status-image confirmed">
                              <img
                                src={orderConfirmedImg}
                                alt="confirmed img"
                              />
                            </span>
                            <span>
                              {t(
                                "trackOrderModalBody.orderNumber.orderConfirmed.text"
                              )}
                            </span>
                          </span>
                          <span>.....</span>
                        </span>
                        <span className={isActive(1, orderDetails?.Status)}>
                          <span>
                            <span className="status-image">
                              <img src={preparingOrderImg} alt="prepared img" />
                            </span>
                            <span>
                              {t(
                                "trackOrderModalBody.orderNumber.preparingOrder.text"
                              )}
                            </span>
                          </span>
                          <span>.....</span>
                        </span>
                        <span className={isActive(2, orderDetails?.Status)}>
                          <span>
                            <span className="status-image">
                              <img src={onItsWayImg} alt="on its way img" />
                            </span>
                            <span>
                              {t(
                                "trackOrderModalBody.orderNumber.onItsWay.text"
                              )}
                            </span>
                          </span>
                          <span>.....</span>
                        </span>

                        <span className={isActive(3, orderDetails?.Status)}>
                          <span>
                            <span className="status-image">
                              <img src={deliveredImg} alt="delivered img" />
                            </span>
                            <span>
                              {t(
                                "trackOrderModalBody.orderNumber.delivered.text"
                              )}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="delivery-status-container">
                      <div className="delivery-status">
                        <div>
                          {t(
                            "trackOrderModalBody.orderNumber.deliveryStatus.text"
                          )}
                          <span className="trackOrder-font">
                            {" "}
                            {orderDetails?.Status}
                          </span>
                        </div>
                      </div>
                      {orderDetails?.LastStatusDate ||
                      orderDetails?.LastStatusTime ? (
                        <div className="lastupdated-status">
                          <div>
                            {t(
                              "trackOrderModalBody.orderNumber.lastUpdated.text"
                            )}
                            <span className="trackOrder-font">
                              {" "}
                              {orderDetails?.LastStatusDate}{" "}
                              {orderDetails?.LastStatusTime}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* <div className="timeline-container">
                  <div>
                    {t("trackOrderModalBody.orderNumber.timeline.text")}:
                  </div>
                  <ul>
                    {orderDetails?.prev_status_timeline.map((timeline) => (
                      <li>
                        {timeline?.description} ({timeline?.last_updated_on})
                      </li>
                    ))}
                  </ul>
                </div> */}
                    </div>
                  </div>
                  <div className="track-order-btn-container re-track">
                    <Button
                      className="track-order-btn"
                      type="emphasised"
                      text={t(
                        "trackOrderModalBody.orderNumber.closeOrTrack.btn.text"
                      )}
                      onClick={() => {
                        closeAndReTrack();
                        resetForm();
                      }}
                    />
                  </div>
                </>
              )}
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default TrackOrderModalBody;
